<div class="retry-block">
  <div class="retry-block__text">
    <span translate="retry-block-scoped.text"></span>
  </div>
  <div class="retry-block__actions">
    <btn
      (action)="retry.emit()"
      link="true"
      iconWidth="24px"
      iconHeight="24px"
      src="./assets/img/icons/loader.svg"
      buttonText="retry-block-scoped.btn"
    ></btn>
  </div>
</div>


